// BISFMCSCertification.jsx
import React from "react";

export default function BISFMCSCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            BIS FMCS Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            BIS FMCS for Foreign Manufacturers - India Market Access
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides assistance for BIS FMCS Certification
            for foreign manufacturers supplying products to the Indian market
            under Foreign Manufacturer Certification Scheme requirements.
          </p>
          <p className="text-gray-700">
            From Authorized Indian Representative (AIR) appointment and product
            standard identification to overseas factory inspection coordination,
            test report validation, and BIS license grant through Manak portal.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: International manufacturing supply chain) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3951963/pexels-photo-3951963.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Global manufacturing factory for BIS FMCS foreign certification"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for BIS FMCS Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks coordinates international documentation for
              FMCS compliance through Authorized Indian Representative.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Foreign manufacturer details including incorporation
                  documents, factory legal status, and ownership verification.
                </li>
                <li>
                  Product specifications with technical drawings, IS standard
                  compliance declaration, and model variant information.
                </li>
                <li>
                  Factory audit information covering manufacturing process,
                  quality control systems, testing facilities, and overseas
                  inspection readiness documentation.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in FMCS as Authorized Indian Representatives
              with expertise in overseas manufacturer compliance.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Expertise in Foreign Manufacturer Compliance
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete FMCS knowledge including AIR appointment, overseas
                  factory audits, test report validation, and BIS license
                  management for India market access.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Certification Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Systematic BIS Manak portal applications, international
                  document coordination, factory inspection preparation, and
                  complete FMCS compliance packages.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end service as AIR from initial eligibility assessment
                  through license grant, surveillance audits, label compliance,
                  and ongoing India market regulatory advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
